import React from "react";
import { Card, CardContent, CardActions, Button, Typography } from "@mui/material";
import { PrimaryColor } from "assets/theme/base/themeColors";

const PaymentMethodCard = ({ paymentMethod }) => {
  return (
    <><Card
      sx={{
        minWidth: 275,
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19)",
        borderRadius: 2,
        background: PrimaryColor,
        color: "white !important",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          component="div"
          sx={{ fontWeight: "bold", color: "white !important" }}
        >
          {paymentMethod.author.props.name}
        </Typography>
      </CardContent>
      {paymentMethod.action}
    </Card>
      </>
  );
};

export default PaymentMethodCard;
